import { createWrapper } from 'next-redux-wrapper'
import { generateStore } from './store'

export const wrapper = createWrapper(generateStore)
